/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Animated, Easing, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import SVG_Svg, { G as SVG_G, GProps, Path as SVG_Path, PathProps } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG - STATE 0
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14" fill="none"> <desc id="IMP.BLUE">{"#Bookmark":{"type":"SELECTOR","constraint":"none","width":100,"height":54},"#Filled_3Dno":{"type":"SELECTOR","constraint":"xMinYMin meet","width":10,"height":14},"#Vector":{"type":"SELECTOR","constraint":"none","width":10,"height":14},"#VectorCenter":{"type":"SELECTOR","constraint":"none","width":9,"height":14},"#Filled_3Dyes":{"type":"SELECTOR","constraint":"xMinYMin meet","width":10,"height":14},"transforms":{},"morph":{"condition":"props.morph","targets":{"Filled=no":{"type":"ease","duration":250,"delay":0},"Filled=yes":{"type":"ease","duration":250,"delay":0}},"numStates":2}}</desc>
 * <g id="Filled=no">
 * <path id="Vector" d="M9.65175 0H0.348115C0.155972 0 3.79485e-07 0.15492 3.79485e-07 0.34607V13.3073C-0.000271568 13.567 0.145637 13.8049 0.377895 13.9236C0.610289 14.0422 0.889868 14.0215 1.10186 13.87L4.99993 11.0921L8.89814 13.8698C9.11027 14.0211 9.38958 14.0416 9.62183 13.9231C9.85395 13.8045 10 13.5667 10 13.3073V0.34607C10 0.15492 9.84403 0 9.65175 0ZM9.30363 13.3072L5.20295 10.3849C5.08166 10.2986 4.91848 10.2986 4.79732 10.3849L0.696502 13.3073V0.69214H9.30363V13.3072Z" fill="#2C4B46"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 1
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14" fill="none">
 * <g id="Filled=yes">
 * <path id="Vector" d="M9.65175 0H0.348115C0.155972 0 3.79485e-07 0.15492 3.79485e-07 0.34607V13.3073C-0.000271568 13.567 0.145637 13.8049 0.377895 13.9236C0.610289 14.0422 0.889868 14.0215 1.10186 13.87L4.99993 11.0921L8.89814 13.8698C9.11027 14.0211 9.38958 14.0416 9.62183 13.9231C9.85395 13.8045 10 13.5667 10 13.3073V0.34607C10 0.15492 9.84403 0 9.65175 0ZM9.30363 13.3072L5.20295 10.3849C5.08166 10.2986 4.91848 10.2986 4.79732 10.3849L0.696502 13.3073V0.69214H9.30363V13.3072Z" fill="#2C4B46"/>
 * <path id="VectorCenter" d="M9.5 13.9998L5.21215 10.7568C5.08531 10.6609 4.91469 10.6609 4.788 10.7568L0.5 14V0H9.5V13.9998Z" fill="#2C4B46"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#Bookmark": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 100,
 * 		"height": 54
 * 	},
 * 	"#Filled_3Dno": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 10,
 * 		"height": 14
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 10,
 * 		"height": 14
 * 	},
 * 	"#VectorCenter": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 9,
 * 		"height": 14
 * 	},
 * 	"#Filled_3Dyes": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 10,
 * 		"height": 14
 * 	},
 * 	"transforms": {},
 * 	"morph": {
 * 		"condition": "props.morph",
 * 		"targets": {
 * 			"Filled=no": {
 * 				"type": "ease",
 * 				"duration": 250,
 * 				"delay": 0
 * 			},
 * 			"Filled=yes": {
 * 				"type": "ease",
 * 				"duration": 250,
 * 				"delay": 0
 * 			}
 * 		},
 * 		"numStates": 2
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  Filled?: "no" | "yes";
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Morphing Types */

type tReactRefUnknown = React.Ref<React.Component<unknown, unknown, unknown>>;
type tMorphRef = Animated.WithAnimatedValue<tReactRefUnknown> & tReactRefUnknown;
type tMorphProps = {
  morphConfigVectorCenteropacity: string | number | Animated.AnimatedInterpolation;
  bindInterpolation: tMorphRef;
};
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const Bookmark = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  Filled?: "no" | "yes";
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 10,
      height: 14,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  const [morphState] = React.useState<{
    morphAnimVal: Animated.Value;
    morphProps: tMorphProps;
  }>({
    morphAnimVal: new Animated.Value(0),
    morphProps: {
      bindInterpolation: () => undefined,
      morphConfigVectorCenteropacity: 0,
    },
  });
  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Morph Wrapper */

  type tMorphProperty = {
    Filled: "no" | "yes";
  };
  type tMorphProperties = {
    [key: string]: tMorphProperty;
  };
  const morphStates: tMorphProperties = {
    0: {
      Filled: "no",
    },
    1: {
      Filled: "yes",
    },
  };

  function getNextMorphState(): number {
    const { Filled, morph = 0 } = props;
    let nextState = morph;
    Object.keys(morphStates).forEach((possibleMorphState) => {
      if (morphStates[possibleMorphState].Filled === Filled) {
        nextState = parseInt(possibleMorphState, 10);
      }
    });
    return nextState;
  }

  const { morphAnimVal, morphProps } = morphState;

  const onAnimationComplete: () => void = props?.onAnimationComplete ?? (() => 0);

  const currValueRef = React.useRef(0);
  const nextValue: number = getNextMorphState() ?? 1;
  const currValue = currValueRef.current;
  let startValue = Math.floor(currValue);
  let endValue = Math.ceil(nextValue);

  if (currValue > nextValue) {
    startValue = Math.ceil(currValue);
    endValue = Math.floor(nextValue);
  }

  const morphValues: {
    [id: string]: string[] | number[];
  } = {
    morphConfigVectorCenteropacity: [0, 1],
  };

  function clamp(lower: number, upper: number, v: number) {
    let r = v;

    if (r > upper) {
      r = upper;
    } else if (r < lower) {
      r = lower;
    }

    return r;
  }

  type tInterpolationRange = {
    inputRange: number[];
    outputRange: string[] | number[];
  };

  function getInterpolationRange(morphId: string, start: number, end: number): tInterpolationRange {
    const initial = clamp(0, 2, start);
    const final = clamp(0, 2, end);
    const inputRange = [start, end];
    const outputRange: string[] | number[] = [morphValues[morphId][initial], morphValues[morphId][final]] as
      | string[]
      | number[];

    if (start > end) {
      inputRange.reverse();
      outputRange.reverse();
    }

    return {
      inputRange,
      outputRange,
    };
  }

  morphProps.morphConfigVectorCenteropacity = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigVectorCenteropacity", startValue, endValue),
  );
  React.useEffect(() => {
    const forwardMorph = [
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 250,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 250,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
    ];

    const restartAnimation = () => {
      const nextInt = Math.ceil(nextValue);

      if (nextInt in forwardMorph) {
        forwardMorph[nextInt]?.start(() => {
          currValueRef.current = nextInt;
          onAnimationComplete();
        });
      }
    };

    if (morphAnimVal && morphAnimVal.stopAnimation) {
      morphAnimVal.stopAnimation(restartAnimation);
    } else {
      restartAnimation();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextValue]);
  /** End Morph Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 10 14"
        >
          <G id="Filled_3Dno">
            <Svg preserveAspectRatio="none" viewBox="0 0 10 14">
              <Path
                id="Vector"
                d="M9.65175 0H0.348115C0.155972 0 3.79485e-07 0.15492 3.79485e-07 0.34607V13.3073C-0.000271568 13.567 0.145637 13.8049 0.377895 13.9236C0.610289 14.0422 0.889868 14.0215 1.10186 13.87L4.99993 11.0921L8.89814 13.8698C9.11027 14.0211 9.38958 14.0416 9.62183 13.9231C9.85395 13.8045 10 13.5667 10 13.3073V0.34607C10 0.15492 9.84403 0 9.65175 0ZM9.30363 13.3072L5.20295 10.3849C5.08166 10.2986 4.91848 10.2986 4.79732 10.3849L0.696502 13.3073V0.69214H9.30363V13.3072Z"
                fill="#2C4B46"
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="none" viewBox="0 0 10 14">
              <Path
                id="VectorCenter"
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
                fill={"#2C4B46" ?? "#2C4B46"}
                opacity={morphProps.morphConfigVectorCenteropacity ?? 0}
                d={
                  "M9.5 13.9998L5.21215 10.7568C5.08531 10.6609 4.91469 10.6609 4.788 10.7568L0.5 14V0H9.5V13.9998Z" ??
                  "M9.5 13.9998L5.21215 10.7568C5.08531 10.6609 4.91469 10.6609 4.788 10.7568L0.5 14V0H9.5V13.9998Z"
                }
              />
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 10 14"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector"
          d="M9.65175 0H0.348115C0.155972 0 3.79485e-07 0.15492 3.79485e-07 0.34607V13.3073C-0.000271568 13.567 0.145637 13.8049 0.377895 13.9236C0.610289 14.0422 0.889868 14.0215 1.10186 13.87L4.99993 11.0921L8.89814 13.8698C9.11027 14.0211 9.38958 14.0416 9.62183 13.9231C9.85395 13.8045 10 13.5667 10 13.3073V0.34607C10 0.15492 9.84403 0 9.65175 0ZM9.30363 13.3072L5.20295 10.3849C5.08166 10.2986 4.91848 10.2986 4.79732 10.3849L0.696502 13.3073V0.69214H9.30363V13.3072Z"
          fill="#2C4B46"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 10 14"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="VectorCenter"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
          fill={"#2C4B46" ?? "#2C4B46"}
          opacity={morphProps.morphConfigVectorCenteropacity ?? 0}
          d={
            "M9.5 13.9998L5.21215 10.7568C5.08531 10.6609 4.91469 10.6609 4.788 10.7568L0.5 14V0H9.5V13.9998Z" ??
            "M9.5 13.9998L5.21215 10.7568C5.08531 10.6609 4.91469 10.6609 4.788 10.7568L0.5 14V0H9.5V13.9998Z"
          }
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(Bookmark);
